import { useEffect } from "react";

const useDisableCopy = () => {
  useEffect(() => {
    const handleSelectStart = (e) => e.preventDefault();
    const handleCopy = (e) => e.preventDefault();

    document.addEventListener("selectstart", handleSelectStart);
    document.addEventListener("copy", handleCopy);

    return () => {
      document.removeEventListener("selectstart", handleSelectStart);
      document.removeEventListener("copy", handleCopy);
    };
  }, []);
};

export default useDisableCopy;
